const mixinLoading = {
  methods: {
    showHideLoading(show = false) {
      this.$emit('cotentLoading', show);
      this.$emit('showHideLoading', show);
    },
  },
};

export default mixinLoading;
